import { Button, SvgIconNames } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './MenuBar.styles';

interface MenuBarItem {
  iconName: SvgIconNames;
  label: string;
}

interface MenuBarProps {
  searchLabel?: string;
  onSearch?: () => void;
}

export const MenuBar = ({ onSearch, searchLabel }: MenuBarProps) => {
  const { t } = useTranslation('chart');

  const items: MenuBarItem[] = [
    {
      iconName: 'Add',
      label: t('chart:menuBar.compare'),
    },
    {
      iconName: 'Indicators',
      label: t('chart:menuBar.indicators'),
    },
    {
      iconName: 'Rating',
      label: t('chart:menuBar.events'),
    },
  ];

  const label = searchLabel ? (
    <S.Label>{searchLabel}</S.Label>
  ) : (
    t('chart:menuBar.search')
  );

  return (
    <S.MenuBarRoot data-testid="menu-bar">
      <S.MenuItemSearch>
        <Button
          iconName="Search"
          label={label}
          variant="empty"
          fullWidth
          aria-label={t('chart:menuBar.search')}
          onClick={onSearch}
        />
      </S.MenuItemSearch>
      {items.map(item => (
        <S.MenuItem key={item.iconName}>
          <Button iconName={item.iconName} label={item.label} variant="empty" />
        </S.MenuItem>
      ))}
    </S.MenuBarRoot>
  );
};
